import { createContext, useContext, useEffect, useState } from "react";
import { fetchMe, adminLogin, clearToken, getToken } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      if (!getToken()) {
        setUser(false);
        setReady(true);
        return;
      }
      try {
        const me = await fetchMe();
        setUser(me);
      } catch {
        clearToken();
        setUser(false);
      } finally {
        setReady(true);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const u = await adminLogin(email, password);
    setUser(u);
    return u;
  };

  const logout = () => {
    clearToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
